const ThematicPagesList = () => import('./components/ThematicPagesList')
const ThematicPagesManage = () => import('./components/ThematicPagesManage')
const PagesConfig = () => import('./components/PagesConfig.vue')

export default [
  {
    path: '/thematic_pages',
    redirect: { name: 'thematicPages.index' }
  },
  {
    name: 'thematicPages.index',
    path: '/thematic_pages/list',
    component: ThematicPagesList,
    meta: {
      hideNavbar: false,
      requiresAuth: true,
      permission: {
        context: 'thematic_pages',
        access: 'read'
      }
    }
  },
  {
    name: 'pages.configs',
    path: '/thematic_pages/configs',
    component: PagesConfig,
    meta: {
      hideNavbar: false,
      requiresAuth: true,
      permission: {
        context: 'thematic_pages',
        access: 'write'
      }
    }
  },
  {
    name: 'thematicPages.manage',
    path: '/thematic_pages/manage/:id?',
    component: ThematicPagesManage,
    meta: {
      hideNavbar: false,
      requiresAuth: true,
      permission: {
        context: 'thematic_pages',
        access: 'write'
      }
    }
  }
]
